import React from "react";
import data from "../../json/News/News.json";
import { Link } from "react-router-dom";
const News = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="2xl:container px-6 md:px-10 lg:px-20  flex justify-center">
        <div className="flex flex-col py-16 md:py-20">
          <div className="flex flex-col items-left gap-3">
            <h1 className="text-32 md:text-48 lg:text-54 text-primarycolor font-semibold">
              {data.Title}
            </h1>
            <p className="text-16 md:text-18 font-regular text-secondaryblack">
              {data.subheading}
            </p>
          </div>
          <div className="grid  md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12 md:mt-20  justify-center">
            {data.news.map((item, id) => (
              <div
                key={id}
                className="w-full md:w-[100%] p-4 sm:p-5 border-[1px] border-border rounded-[24px] hover:shadow-products"
              >
                <div className="w-full rounded-[24px]">
                  <img
                    src={process.env.PUBLIC_URL + item.img}
                    alt="newsimg"
                    className="w-full rounded-[16px]"
                  ></img>
                </div>
                <div className="mt-[18px] flex flex-col gap-2 min-h-[110px]">
                  <p className="text-16 md:text-18 text-secodaryblack font-regular">
                    {item.date}
                  </p>
                  <h4 className="text-18 md:text-20 text-primarycolor font-medium">
                    {item.shortnews}
                  </h4>
                </div>
                <Link  to={`/company/Newsdetail/${id}`}>
                  <div className="text-16  text-ctaorange font-semibold mt-4 sm:mt-6">
                    <p className="bio hover:text-btnhover flex items-center gap-2">
                      READ NEWS{" "}
                      {/* <span>
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/orangearrow.png"
                          }
                          alt="."
                        />
                      </span> */}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
